export default __webpack_public_path__ + "static/image5-c49e774968f80b00f7bb8d606e180cb5.jpg";